// extracted by mini-css-extract-plugin
export default {"container":"styles---container---ASrIH","clickable":"styles---clickable---o0wfx"};